export function headerInit() {
	document.addEventListener( 'DOMContentLoaded', function() {
		if ( document.getElementById( 'masthead' ) ) {
			// Header open logic
			const openMobileHeader = () => document.getElementById( 'site-navigation' ).classList.toggle( 'active' );
			const closeMobileHeader = () => document.getElementById( 'site-navigation' ).classList.toggle( 'active' );

			document.getElementById( 'mobile-nav-open' ).addEventListener( 'click', openMobileHeader );
			document.getElementById( 'mobile-nav-close' ).addEventListener( 'click', closeMobileHeader );

			// Header scroll logic
			let prevScroll = window.scrollY;
			const header = document.querySelector( 'header' );
			const top = header.offsetTop + 130;

			window.onscroll = () => {
				const currentScroll = window.scrollY;

				if ( currentScroll >= top ) {
					header.classList.add( 'static' );
				} else {
					header.classList.remove( 'static' );
				}

				if ( prevScroll >= currentScroll ) {
					header.style.top = '0';
				} else {
					header.style.top = '-300px';
				}

				prevScroll = currentScroll;
			};

			// Language switcher.
			const langToggle = document.querySelector( '#site-header-menu-lang__toggle' );
			const toggleArrow = langToggle.lastElementChild;
			const langMenuPanel = document.querySelector( '#site-header-menu-lang__panel' );

			const toggleLanguageMenu = () => {
				if ( langToggle.hasAttribute( 'aria-controls' ) ) {
					langToggle.removeAttribute( 'aria-controls' );
				} else {
					langToggle.setAttribute( 'aria-controls', 'site-header-menu-lang__panel' );
				}

				toggleArrow.classList.toggle( 'reversed' );
				langMenuPanel.classList.toggle( 'visible' );

				if ( langMenuPanel.classList.contains( 'visible' ) ) {
					langToggle.setAttribute( 'aria-expanded', 'true' );
					langMenuPanel.querySelector( '.site-header-menu-lang__panel-list-item a' ).focus();
				} else {
					langToggle.setAttribute( 'aria-expanded', 'false' );
					langToggle.focus();
				}
			};

			// Event listener for click and keyboard.
			langToggle.addEventListener( 'click', toggleLanguageMenu );
			langToggle.addEventListener( 'keydown', ( event ) => {
				if ( event.key === 'Enter' ) {
					toggleLanguageMenu();
				}
			} );

			// Close the language menu with Escape key
			document.addEventListener( 'keydown', ( event ) => {
				if ( event.key === 'Escape' && langMenuPanel.classList.contains( 'visible' ) ) {
					toggleLanguageMenu();
					langToggle.focus();
				}
			} );

			// Focus trap for the language menu.
			const focusableElements = Array.from( langMenuPanel.querySelectorAll( 'a, button' ) );
			focusableElements.unshift( langToggle );
			const firstFocusableElement = focusableElements[ 0 ];
			const lastFocusableElement = focusableElements[ focusableElements.length - 1 ];

			langMenuPanel.addEventListener( 'keydown', ( event ) => {
				const activeElement = langMenuPanel.ownerDocument.activeElement;

				if ( event.key === 'Tab' ) {
					if ( event.shiftKey ) { // Shift + Tab
						if ( activeElement === firstFocusableElement ) {
							event.preventDefault();
							lastFocusableElement.focus();
						}
					} else if ( ! event.shiftKey && activeElement === lastFocusableElement ) { // Tab
						event.preventDefault();
						firstFocusableElement.focus();
					}
				}
			} );

			// Application menu toggle logic.
			const applicationMenu = document.querySelector( '.js-application-menu' );
			const applicationMenuOverlay = document.querySelector( '.js-application-menu-overlay' );
			const applicationMenuClose = document.querySelector( '.js-application-menu-close' );
			const applicationButton = document.getElementById( 'application-button' );

			if ( applicationMenu && applicationMenuOverlay && applicationMenuClose && applicationButton ) {
				// Open menu function.
				const openApplicationMenu = () => {
					applicationMenu.classList.add( 'active' );
					applicationMenuOverlay.classList.add( 'active' );
					document.body.style.overflow = 'hidden';
				};

				// Close menu function.
				const closeApplicationMenu = () => {
					applicationMenu.classList.remove( 'active' );
					applicationMenuOverlay.classList.remove( 'active' );
					document.body.style.overflow = '';
				};

				// Open button click.
				applicationButton.addEventListener( 'click', openApplicationMenu );

				// Close button click.
				applicationMenuClose.addEventListener( 'click', closeApplicationMenu );

				// Overlay click to close.
				applicationMenuOverlay.addEventListener( 'click', closeApplicationMenu );

				// Escape key to close.
				document.addEventListener( 'keydown', ( event ) => {
					if ( event.key === 'Escape' && applicationMenu.classList.contains( 'active' ) ) {
						closeApplicationMenu();
					}
				} );
			}
		}
	} );
}
